var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancellOrderOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21564_80700",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21564_80700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 18L13 14.4L16.6 18L18 16.6L14.4 13L18 9.4L16.6 8L13 11.6L9.4 8L8 9.4L11.6 13L8 16.6L9.4 18ZM13 23C11.6167 23 10.3167 22.7373 9.1 22.212C7.88333 21.6873 6.825 20.975 5.925 20.075C5.025 19.175 4.31267 18.1167 3.788 16.9C3.26267 15.6833 3 14.3833 3 13C3 11.6167 3.26267 10.3167 3.788 9.1C4.31267 7.88333 5.025 6.825 5.925 5.925C6.825 5.025 7.88333 4.31233 9.1 3.787C10.3167 3.26233 11.6167 3 13 3C14.3833 3 15.6833 3.26233 16.9 3.787C18.1167 4.31233 19.175 5.025 20.075 5.925C20.975 6.825 21.6873 7.88333 22.212 9.1C22.7373 10.3167 23 11.6167 23 13C23 14.3833 22.7373 15.6833 22.212 16.9C21.6873 18.1167 20.975 19.175 20.075 20.075C19.175 20.975 18.1167 21.6873 16.9 22.212C15.6833 22.7373 14.3833 23 13 23Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellOrderOff);
export default __webpack_public_path__ + "static/media/CancellOrderOff.eb4488725717f0ed309a714904e7d735.svg";
export { ForwardRef as ReactComponent };